
import { NgClass, NgStyle } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, ViewChild, input } from '@angular/core';
import * as acorn from 'acorn';
import { ButtonModule } from "primeng/button";
import { CodemirrorDannComponent } from 'src/app/shared/components/ai-bot/utils/codemirror-dann/codemirror-dann.component';
import { BlocklyStorageService } from '../../services/blockly-storage.service';
import { EditorItemsService } from '../../services/editor-items.service';
import { RouteShareService } from '../../services/route-share.service';
import { BlocklyChangedEvent, BlocklyEditorComponent } from '../blockly/blockly-editor/blockly-editor.component';



@Component({
  selector: 'app-botscript-editor-combined',
  imports: [NgClass, NgStyle, CodemirrorDannComponent, BlocklyEditorComponent, ButtonModule],
  templateUrl: './botscript-editor-combined.component.html',
  styleUrl: './botscript-editor-combined.component.scss',
  host: { class: 'split-container' }
})
export class BotscriptEditorCombinedComponent implements OnInit, AfterViewInit {


  @ViewChild('left', { static: false }) public left!: ElementRef<HTMLDivElement>;
  @ViewChild('right', { static: false }) public right!: ElementRef<HTMLDivElement>;
  @ViewChild('resizer', { static: false }) public resizer!: ElementRef<HTMLDivElement>;



  @Input() public showCodeArea: boolean = true;
  public readonly forceCodeArea = input<boolean>(false);
  @ViewChild('blocklyEditor', { static: false }) public blocklyEditor?: BlocklyEditorComponent;
  //  public blocklyIsPossible: boolean = true;
  public showBlocklyAfterDelay = false;
  public showConfirmModal = false;
  public jsSyntaxError: string | null = null;
  public cursorLine: number = 1;
  public cursorCol: number = 1;
  private switchToCodeEditorResolve: (() => void) | null = null;

  constructor(private blocklyStorage: BlocklyStorageService,
    public editorItemService: EditorItemsService,
    public rss: RouteShareService,
    private host: ElementRef<HTMLElement>,
    private cdr: ChangeDetectorRef) { }

  public ngAfterViewInit(): void {
    //    const l = localStorage.getItem('botscriptEditorLeftWidth');
    //  const r = localStorage.getItem('botscriptEditorRightWidth');
    /*  if (l && r) {
       this.leftCol.nativeElement.style.width = `${l}px`;
       this.rightCol.nativeElement.style.width = `${r}px`;
     } */

    const codeareaAfterReload = localStorage.getItem('showCodeArea');
    if (codeareaAfterReload) {
      this.showCodeArea = codeareaAfterReload === "true";
    } else {
      this.showCodeArea = false;
    }

  }


  public isDirty() {
    if (this.rss.editorItem) {
      return this.rss.editorItem.isDirty;
    }
    return false;
  }

  public toggleCodeArea() {

    this.showCodeArea = !this.showCodeArea;

    this.blocklyEditor?.invalidateView();
    localStorage.setItem('showCodeArea', this.showCodeArea.toString());
  }

  public ngOnInit(): void {
    this.showBlocklyAfterDelay = false;
    setTimeout(() => {
      this.showBlocklyAfterDelay = true;
      this.cdr.detectChanges();
    }, 1);
  }

  public async onBlocklyChange(changeEvent: BlocklyChangedEvent) {

    if (this.rss.editorItem) {


      this.rss.editorItem.isDirty = false;
      if (this.rss.editorItem.uniqueId) {
        await this.blocklyStorage.updateStage(this.rss.editorItem.uniqueId, changeEvent.xml, "");
        await this.rss.editorItem.onFinishMethod(changeEvent.code);
        this.rss.editorItem.code = changeEvent.code;

      }
    }
    this.validateJsSyntax();
  }

  public validateJsSyntax(): void {
    const code = this.blocklyEditor?.currentCode;
    if (!code || code.trim() === '') {
      this.jsSyntaxError = null;
      return;
    }
    try {
      acorn.parse(code, { ecmaVersion: 'latest', sourceType: 'script', allowAwaitOutsideFunction: true }); this.jsSyntaxError = null;
    } catch (e: unknown) {
      if (e instanceof SyntaxError) {
        const loc = (e as SyntaxError & { loc?: { line: number; column: number } }).loc;
        this.jsSyntaxError = loc
          ? `Zeile ${String(loc.line)}: ${e.message}`
          : e.message;
      } else {
        this.jsSyntaxError = 'Unbekannter Syntaxfehler';
      }
    }
  }

  public onCursorMove(textarea: HTMLTextAreaElement): void {
    const pos = textarea.selectionStart;
    const text = textarea.value.substring(0, pos);
    this.cursorLine = text.split('\n').length;
    this.cursorCol = pos - text.lastIndexOf('\n');
  }

  public async switchToCodeEditor() {
    return new Promise<void>((resolve) => {
      this.switchToCodeEditorResolve = () => {
        resolve();
        this.switchToCodeEditorResolve = null;
      };
      this.showConfirmModal = true;
    }).then(async () => {

      console.log(this.rss.editorItem);
      if (!this.rss.editorItem) return;
      await this.blocklyStorage.deleteStage(this.rss.editorItem.uniqueId);
      this.blocklyEditor?.clearWorkspace();
      this.rss.editorItem.xml = "";
      console.log("SWITCH TO EDITO RITEM 2", this.rss.editorItems);

      //    this.editorItemService.seletItem(this.rss.editorItem.uniqueId);
      if (this.rss.editorItem.code.trim() === "") {
        this.rss.editorItem.code = "//REMOVE TO ENABLE VISUAL EDITOR\n";
        void this.rss.editorItem.onFinishMethod(this.rss.editorItem.code);
      }
    });
  }

  public confirmSwitchToCodeEditor() {
    this.showConfirmModal = false;
    this.switchToCodeEditorResolve?.();
  }


  public showBlocklyInLayout() {
    if (this.forceCodeArea()) return false;
    if (this.editorItemService.blocklyIsPossible()) return true;
    return false;
  }

  public showResizerInLayout() {
    if (!this.showBlocklyInLayout()) return false;
    if (!this.showCodeEditorInLayout()) return false;
    return true;
  }

  public showCodeEditorInLayout() {
    if (this.forceCodeArea()) return true;
    if (!this.editorItemService.blocklyIsPossible()) return true;
    return this.showCodeArea;
  }



  public invalidate() {

    if (this.blocklyEditor) {
      this.blocklyEditor.invalidateView();
    }


  }



  private isResizing = false;

  public startResize(_: MouseEvent): void {
    this.isResizing = true;
    document.body.style.cursor = 'col-resize';
  }


  @HostListener('document:mousemove', ['$event'])
  public onMouseMove(e: MouseEvent): void {
    if (this.isResizing) {
      this.host.nativeElement.classList.add('is-resizing');
    } else {
      this.host.nativeElement.classList.remove('is-resizing');
    }
    if (!this.isResizing) return;


    const containerRect = this.host.nativeElement.getBoundingClientRect();
    const pointerX = e.clientX - containerRect.left;            // Cursor relativ zum Container
    const minWidth = 100;                                       // Mindestbreite der Spalten
    const leftWidth = Math.max(minWidth, pointerX);

    // Breiten setzen
    this.left.nativeElement.style.width = `${leftWidth + ""}px`;
    //this.right.nativeElement.style.width = `${rightWidth}px`;
  }

  @HostListener('document:mouseup')
  public stopResize(): void {
    this.invalidate();
    if (this.isResizing) {
      this.isResizing = false;
      document.body.style.cursor = 'default';
    }
  }
}
